export default "__VITE_ASSET__DsWE0ZDf__"